<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目ID">
              <a-input placeholder="请输入项目ID" v-model="queryParam.projectId"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目中的受试者字段配置ID">
              <a-input placeholder="请输入项目中的受试者字段配置ID" v-model="queryParam.patientFieldId"></a-input>
            </a-form-item>
          </a-col>

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectPixConfig-modal ref="modalForm" @ok="modalFormOk"></projectPixConfig-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectPixConfigModal from './modules/ProjectPixConfigModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "ProjectPixConfigList",
    mixins:[JeecgListMixin],
    components: {
      ProjectPixConfigModal
    },
    data () {
      return {
        description: '项目的受试者交叉索引配置，当配置了字段，注册受试者的时候，会自动生成该字段的交叉索引管理页面',
        // 表头
        columns: [
		   {
            title: '项目ID',
            align:"center",
            dataIndex: 'projectId'
           },
		   {
            title: '项目中的受试者字段配置ID',
            align:"center",
            dataIndex: 'patientFieldId'
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/project/projectPixConfig/list",
          delete: "/project/projectPixConfig/delete",
       },
    }
  },
  computed: {
  },
    methods: {
     
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>